import { render, staticRenderFns } from "./ContactsHome.vue?vue&type=template&id=e83be6ae&scoped=true&"
import script from "./ContactsHome.vue?vue&type=script&lang=js&"
export * from "./ContactsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83be6ae",
  null
  
)

export default component.exports